<template>
  <section class="container">
    <layout-breadcrumb :items="breadcrumbs"></layout-breadcrumb>
    <!-- Mapa de Voluntarios -->
    <div class="row justify-content-center mt-5">
      <div class="col-md-10 col-lg-8">
        <view-mapa-voluntarios></view-mapa-voluntarios>
      </div>
    </div>
    
    <div class="row justify-content-around mt-5">
      <div class="col-sm-6 col-xs-12 col-md-5 col-lg-5 mt-3">
        <a :href="'voluntariado/escuela-observadores-democraticos'">
          <div class="media bg-transparencia px-5 py-6 image-round-all transition-hover hover-shadow-9" style="height: 200px;">
            <div class="mr-5 d-flex align-items-center">
              <img :src="fileWebUrl('assets/images/eod_amarillo.png')" alt="" class="img-fluid img-vol-act" style="width: 5rem; height: auto" />
            </div>
            <div class="media-body text-white d-flex flex-column justify-content-center">
              <h3 class="h5 mt-0 mb-2" style="line-height: 1.2;">Escuela de observadores Democráticos</h3>
              <p class="mb-0" style="line-height: 1.3;">Conoce los módulos y forma parte de nuestro equipo de observadores electorales</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-sm-6 col-xs-12 col-md-5 col-lg-5 mt-3">
        <a :href="'voluntariado/info'">
        <div class="media bg-transparencia px-5 py-6 image-round-all transition-hover hover-shadow-9" style="height: 200px;">
            <div class="mr-5 d-flex align-items-center">
              <img :src="fileWebUrl('assets/images/voluntariado_amarillo.png')" alt="" class="img-fluid img-vol-act" style="width: 5rem; height: auto" />
            </div>
            <div class="media-body text-white d-flex flex-column justify-content-center">
              <h3 class="h5 mt-0 mb-2" style="line-height: 1.2;">Voluntariado</h3>
              <p class="mb-0" style="line-height: 1.3;">Conoce y únete a nuestra red de voluntariado a nivel nacional</p>
            </div>
          </div>
        </a>
      </div>
    </div>
    <!-- Nuevos botones ---->
    <div class="row justify-content-around mt-5">
      <div class="col-sm-6 col-xs-12 col-md-5 col-lg-5 mt-3">
        <a :href="'voluntariado/actividades'">
          <div class="media bg-transparencia px-5 py-6 image-round-all transition-hover hover-shadow-9" style="height: 200px;">
            <div class="mr-5 d-flex align-items-center">
              <img :src="fileWebUrl('assets/images/actividades_amarillo.png')" alt="" class="img-fluid img-vol-act" style="width: 5rem; height: auto" />
            </div>
            <div class="media-body text-white d-flex flex-column justify-content-center">
              <h3 class="h5 mt-0 mb-2" style="line-height: 1.2;">Actividades</h3>
              <p class="mb-0" style="line-height: 1.3;">Conoce las actividades que realizamos con la comunidad de voluntarios y voluntarias.</p>
            </div>
          </div>
        </a>
      </div>
      <div class="col-sm-6 col-xs-12 col-md-5 col-lg-5 mt-3">
        <a :href="'voluntariado/coordinadores'">
        <div class="media bg-transparencia px-5 py-6 image-round-all transition-hover hover-shadow-9" style="height: 200px;">
            <div class="mr-5 d-flex align-items-center">
              <img :src="fileWebUrl('assets/images/coordinadores_amarillo.png')" alt="" class="img-fluid img-vol-act" style="width: 5rem; height: auto" />
            </div>
            <div class="media-body text-white d-flex flex-column justify-content-center">
              <h3 class="h5 mt-0 mb-2" style="line-height: 1.2;">Coordinadores Regionales</h3>
              <p class="mb-0" style="line-height: 1.3;">Conoce a los coordinadores y coordinadoras de tu región.</p>
            </div>
          </div>
        </a>
      </div>
    </div>
    <!-- -->


    <!-- <div class="row justify-content-center mt-7">
      <div class="col-sm-12 col-xs-12 col-md-9 col-lg-9 text-center">
        <p class="text-dark">
          <span>¿Deseas formar parte de la Red Nacional de Voluntariado de Transparencia?</span><br />
          <span>Escribe al siguiente correo: voluntariado@transparencia.org.pe</span> <br />
          <span>Enviando tu nombre completo, región de residencia y datos de contacto (celular y/o correo electrónico).</span>
        </p>
      </div>
    </div> -->
  </section>
</template>

<script>
import layoutBreadcrumb from "@/layout/layout-breadcrumb";
import viewMapaVoluntarios from "@/components/share/view-mapa-voluntarios";

export default {
  name: "view-voluntariado",
  metaInfo: {
    title: "Voluntariado",
  },
  data: () => ({
    // Sin datos del backend
  }),
  components: { 
    layoutBreadcrumb,
    viewMapaVoluntarios
  },
  methods: {
    // Sin métodos de llamada al backend
  },
  mounted: function() {
    this.breadcrumbs = [
      { name: "Inicio", url: "/home", icon: "fa fa-home", active: false },
      { name: "Voluntariado", url: "", icon: "", active: true },
    ];
  },
};
</script>
